import { REQUEST_PAID_EVENT_STREAMS, RECEIVE_PAID_EVENT_STREAMS } from './paidEventsActions'
import { LOG_OUT } from '../../top-panel/authorized-controls/authorizationActions'

const initialState = {
  isLoading: true,
  streams: undefined
}

export default (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_PAID_EVENT_STREAMS:
      return { ...initialState, isLoading: true }

    case RECEIVE_PAID_EVENT_STREAMS:
      return {
        isLoading: false,
        streams: action.streams
      }

    case LOG_OUT:
      return { ...initialState }
    default: return state
  }
}
